import { render, staticRenderFns } from "./SidebarCrmOverviewBlock.vue?vue&type=template&id=1de4c88a&scoped=true"
import script from "./SidebarCrmOverviewBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarCrmOverviewBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarCrmOverviewBlock.vue?vue&type=style&index=0&id=1de4c88a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de4c88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de4c88a')) {
      api.createRecord('1de4c88a', component.options)
    } else {
      api.reload('1de4c88a', component.options)
    }
    module.hot.accept("./SidebarCrmOverviewBlock.vue?vue&type=template&id=1de4c88a&scoped=true", function () {
      api.rerender('1de4c88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarCrmOverviewBlock.vue"
export default component.exports